<!-- Stacked Layout (for multi-column with vertical separators) -->
@if (showStars && isStacked) {
  <div
    class="flex flex-col gap-2 cursor-pointer {{ cssClasses }}"
    (click)="openTrustpilot()">
    <!-- Top: Stars + Rating -->
    <div class="flex items-center gap-2">
      <img class="h-[24px] w-[128px] shrink-0"
        height="24"
        width="128"
        [src]="trustpilotImage"
        alt="Trustpilot Star Rating" />
      @if (trustpilotVerified) {
        <span class="!text-base font-extrabold">
          {{ trustpilotTrustScore }}/5
        </span>
      }
    </div>
    <!-- Bottom: Review count -->
    @if (trustpilotVerified) {
      <span class="!text-base">
        Based on {{ trustpilotNumberOfReviews | number }} reviews
      </span>
    }
  </div>
}

<!-- Horizontal Layout (default) -->
@if (showStars && !isStacked) {
  <div
    class="flex flex-wrap content-start gap-[8px] cursor-pointer {{ cssClasses }}"
    (click)="openTrustpilot()">
    <img
      class="h-[28px] w-[150px]"
      height="28"
      width="150"
      [src]="trustpilotImage"
      alt="Trustpilot Star Rating"
      />
    @if (trustpilotVerified) {
      <div class="flex items-center text-xs xxsm:text-sm xs:text-base [&_span]:![font-size:inherit]">
        <span class="mr-2.5"
          ><span class="font-extrabold">{{ trustpilotTrustScore }}/5</span> Stars</span
          >
        <span
          ><span class="font-extrabold">{{ trustpilotNumberOfReviews | number }}</span> Reviews</span
          >
      </div>
    }
  </div>
}
